import Converter from './Converter';
import { shortLanguages } from 'services/locale';
import { CasinoType, ICasinoProviderConfigurationItem } from 'modules/Casino/types/configuration';
import { projectName } from 'modules/Casino/utils/slots';
import { parseCookies } from '../../utils/parseCookies';
import { QueryTypes } from 'modules/Casino/types/enums/api';

const converter = new Converter();

export const config: ICasinoProviderConfigurationItem<Converter> = {
  type: CasinoType.slots,
  gameListUrl: `rubiplay/game_list?partner_name=${projectName}`,
  converter,
  sessionUrlData: {
    url: 'rubiplay/open_session',
    method: QueryTypes.GET,
    converter: converter.convertGameUrl,
    getQuery: params =>
      `?game_code=${params.gameId}&lang=${shortLanguages[params.lang as keyof typeof shortLanguages]}`,
    getHeaders: () => ({
      headers: {
        'x-partner-name': projectName,
        'x-partner-authorization': parseCookies(),
      },
    }),
  },
};
